import * as tvx from "../../lib/tvx-plugin-module.min";
import {
  MSXContentRoot,
  MSXContentItem,
  MSXContentPage,
} from "../../lib/tvx-plugin-module.min";

import {
  res_blackColor,
  res_country,
  res_director,
  res_imdb_rating,
  res_information,
  res_no_info,
  res_year,
  res_yellowColor,
  res_you_may_also_like,
  serviceMap,
} from "../../static-res";
import {
  base64ToObj,
  callCallback,
  createContentRequest,
  objToBase64,
  stopLoadingShowError,
  STORAGE_PREFIX_ID,
} from "../../utils";
import { getMovieInfo, getSimilarFictions } from "../../api/worker";
import { apiMovie, apiSerial, FictionState } from "../../api/api-models";
import {
  getCurrentlyDisplayingItemByIndex,
  getDisplayedItems,
  truncateString,
} from "../content-utils";

export function getFictionState(fictionId: string): FictionState {
  const showStateString = tvx.Services.storage.get(
    STORAGE_PREFIX_ID + fictionId,
    null
  );
  const showState = base64ToObj(showStateString);
  return showState;
}

export function setFictionState(fictionId: string, state: FictionState) {
  const storage = tvx.Services.storage;
  const stateString = objToBase64(state);
  storage.set(STORAGE_PREFIX_ID + fictionId, stateString);
}
export function createFictionInfo(
  fiction: apiMovie | apiSerial
): MSXContentPage {
  const page: MSXContentPage = {
    headline: res_information(),
    items: [
      {
        type: "default",
        headline: res_year(),
        text:
          fiction.releaseYear != undefined
            ? fiction.releaseYear.toString()
            : res_no_info(),
        alignment: "center",
        centration: "text|title",
        layout: "0,0,3,3",
      },
      {
        type: "default",
        headline: res_imdb_rating(),
        text: fiction.rating.toString(),
        alignment: "center",
        centration: "text|title",
        layout: "3,0,3,3",
      },
      {
        type: "default",
        headline: res_country(),
        text: fiction.country != undefined ? fiction.country : res_no_info(),
        alignment: "center",
        centration: "text|title",
        layout: "6,0,3,3",
      },
      {
        type: "default",
        headline: res_director(),
        text:
          fiction.fiction.directors != undefined
            ? fiction.fiction.directors
                .flatMap((person) => person.personName)
                .join(", ")
            : res_no_info(),
        alignment: "center",
        centration: "text|title",
        layout: "9,0,3,3",
      },
    ],
  };

  return page;
}

let mapAlsoLikeIndex: Map<string, number> = new Map();
let mapAlsoLikeFictiions: Map<string, (apiMovie | apiSerial)[]> = new Map();

export function getDestFictionByRootFictionId(
  fictionId: string,
  itemIndex: string
): apiMovie | apiSerial {
  const fictions = mapAlsoLikeFictiions.get(fictionId);
  const listIndex = mapAlsoLikeIndex.get(fictionId);
  return getCurrentlyDisplayingItemByIndex(
    fictions,
    listIndex,
    Number.parseInt(itemIndex)
  );
}
export function updateFictionAlsoLikesRow(
  fictionId: string,
  type: number
): void {
  const displaingFictions = getDisplayedItems(
    mapAlsoLikeFictiions.get(fictionId),
    mapAlsoLikeIndex.get(fictionId),
    type
  );

  const fictions = displaingFictions.items as apiMovie[];
  mapAlsoLikeIndex.set(fictionId, displaingFictions.newIndex);
  for (let i = 0; i < 5; i++) {
    tvx.InteractionPlugin.executeAction(
      `update:content:fiction-${fictionId}-also-${i + 1}`,
      {
        image: fictions[i].portraitImage,
        title: fictions[i].title.toUpperCase(),
      }
    );
  }
  tvx.InteractionPlugin.stopLoading();
}
export async function createFictionAlsoLikeRow(
  kind: string,
  fictionId: string
): Promise<MSXContentPage> {
  return getSimilarFictions(kind, fictionId).then((fictions) => {
    mapAlsoLikeIndex.set(fictionId, 0);
    mapAlsoLikeFictiions.set(fictionId, fictions);
    const page: MSXContentPage = {
      headline: res_you_may_also_like(),
      items: [
        {
          display: fictions.length > 5,
          type: "default",
          layout: "0,0,1,3",
          icon: "arrow-back-ios",
          iconSize: "small",
          action:
            "interaction:commit:message:content:fiction:also_like:back:" +
            fictionId,
        },
        {
          display: fictions.length > 5,
          type: "default",
          layout: "11,0,1,3",
          icon: "arrow-forward-ios",
          iconSize: "small",
          action:
            "interaction:commit:message:content:fiction:also_like:forward:" +
            fictionId,
        },
      ],
    };
    for (let i = 0; i < Math.min(5, fictions.length); i++) {
      page.items.push(
        createAlsoLikeFictionItem(kind, fictionId, fictions[i], i + 1)
      );
    }

    return page;
  });
}

function createAlsoLikeFictionItem(
  kind: string,
  fictionId: string,
  fiction: apiMovie | apiSerial,
  index: number
): MSXContentItem {
  return {
    id: `fiction-${fictionId}-also-${index}`,
    image: fiction.portraitImage,
    layout: `${index * 2 - 1},0,2,4`,
    type: "separate",
    color: "msx-glass",
    imageFiller: "cover",
    title: fiction.title.toUpperCase(),
    action:
      "content:" +
      createContentRequest(`fiction:also:${kind}:${fictionId}:${index}`),
  };
}
